import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ApiError } from 'src/types/interfaces/api-error';
import { delayedCallbackExecution } from 'src/utils/delayed-callback-execution';
import { deleteBookingRules } from '../lib/booking-rules';
import { bookingRulesKeys } from '../query-keys/booking-rules';

export const useDeleteBookingRules = (onSuccess?: () => void) => {
  const { t } = useTranslation(['bookingRules', 'common']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (token: string) => deleteBookingRules(token),
    onSuccess: () => {
      delayedCallbackExecution(1000, () => {
        queryClient.invalidateQueries({
          queryKey: bookingRulesKeys.lists(),
        });
      });
      toast.success(t('bookingRules:common.deleteBookingRulesDialog.success'));
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(
        error?.response?.data?.message ||
          t('common:errorMessages.somethingWentWrong'),
      );
    },
  });
};
